/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Smarts Conversation UI
 *| (C) Copyright IBM Corp. 2020
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
/*
 * serialize regression model to json
 *
 */
import TargetEncoder from './TargetEncoder'
import MinMaxScaler from './MinMaxScaler'
import RegressionModel from './RegressionModel'
import * as tf from '@tensorflow/tfjs'

export function whatIfModelToJson(regModel) {
	let obj = {};
	obj['xNormalizer'] = { 'min': Array.from(regModel.xNormalizer.getMin()), 'max': Array.from(regModel.xNormalizer.getMax())};
	obj['yNormalizer'] = { 'min': Array.from(regModel.yNormalizer.getMin()), 'max': Array.from(regModel.yNormalizer.getMax()) };
	obj['encoder'] = { 'types': regModel.encoder.types, 'yMean': regModel.encoder.yMean, 'averages': JSON.stringify(regModel.encoder.averages) };
	obj['batchSize'] = regModel.batchSize || false;
	obj['epochs'] = regModel.epochs || false;
	obj['layers'] = regModel.layers || false;
	obj['learningRate'] = regModel.learningRate || false;

	obj['inputShape'] = regModel.model.layers[0].weights[0].shape[0];
	obj['weights'] = [];
	regModel.model.layers.map(l => {
		let w = l.getWeights()[0];
		let b = l.getWeights()[1];
		let weights = { 'w': { 'data': Array.from(w.dataSync()), 'shape': Array.from(w.shape) }, 'b': { 'data': Array.from(b.dataSync()), 'shape': Array.from(b.shape)} };
		obj['weights'].push(weights)
	})
	return JSON.stringify(obj);
}

export function buildWhatIfModelFromJson(json) {
	const obj = JSON.parse(json);
	let res = {};
	
	const xNormalizer = new MinMaxScaler();
	xNormalizer.setMinMaxValues(obj.xNormalizer.min, obj.xNormalizer.max);
	const yNormalizer = new MinMaxScaler();
	yNormalizer.setMinMaxValues(obj.yNormalizer.min, obj.yNormalizer.max);
	const encoder = new TargetEncoder();
	encoder.setTypes(obj.encoder.types);
	encoder.setYMean(obj.encoder.yMean);
	encoder.setAverages(JSON.parse(obj.encoder.averages));

	let config = {
		xNormalizer,
		yNormalizer,
		encoder
	}
	config.batchSize = obj.batchSize || false;
	config.epochs = obj.epochs || false;
	config.layers = obj.layers || false;
	config.learningRate = obj.learningRate || false;
	let regressionModel = new RegressionModel(config);
	regressionModel.model = regressionModel.buildModel(obj['inputShape']);
	_setWeights(obj.weights, regressionModel.model);
	return regressionModel;
}
function _setWeights(weights, model) {
	for (let i = 0; i < weights.length; i++) {
		let w = tf.tensor(weights[i].w.data, weights[i].w.shape);
		let b = tf.tensor(weights[i].b.data, weights[i].b.shape);
		model.layers[i].setWeights([w, b]);
	}
}